// SelectedClientSignalBrief — full-width client-signal brief.
//
// Reuses the existing `ClientTrackDetailPanel` for the brief body so all
// the existing collapsible sections (interpretation / impact / matrix
// cells / actions / blind spots / related signals / weekly history)
// render at full parity with the production Client View.
//
// Adds a "Organizational exposure" section below the brief that mounts
// the existing `ScopedImpactMatrix` so the workbench doesn't lose the
// matrix / exposure view when a signal is selected.

import React from "react";
import ClientTrackDetailPanel from "../dashboard/client/ClientTrackDetailPanel";
import ScopedImpactMatrix from "../dashboard/client/ScopedImpactMatrix";

const SelectedClientSignalBrief = ({ card, validTrackIds, trackLabelById, onSelectTrack, exposureMatrix, impactCellAssessments, clientProfile }) => {
    if (!card) {
        return (
            <div className="card-flat p-6 text-sm text-[hsl(var(--mute))] text-center" data-testid="workbench-client-brief-empty">
                Select a signal in the table above to see its client-specific brief here.
            </div>
        );
    }
    return (
        <section data-testid="workbench-client-brief" className="space-y-4">
            <div>
                <div className="eyebrow mb-2">Selected client signal brief</div>
                <ClientTrackDetailPanel
                    card={card}
                    validTrackIds={validTrackIds}
                    trackLabelById={trackLabelById}
                    onSelectTrack={onSelectTrack}
                />
            </div>
            {(exposureMatrix || impactCellAssessments) && (
                <div data-testid="workbench-client-exposure">
                    <div className="eyebrow mb-2">Organizational exposure for this signal</div>
                    <ScopedImpactMatrix
                        selectedTrack={card}
                        exposureMatrix={exposureMatrix}
                        impactCellAssessments={impactCellAssessments}
                        clientProfile={clientProfile}
                        onSelectTrack={onSelectTrack}
                    />
                </div>
            )}
        </section>
    );
};

export default SelectedClientSignalBrief;
